const makeInitialState = () => ({
  allRecordings: [],
  status: {
    recording: 'Unfetched',
    allRecordings: 'Unfetched',
    events: 'Unfetched',
  },
  currentId: null,
  events: [],
  aspirationalSeekMS: null,
  videoReady: false,
  videoPlaying: false,
  videoError: null,
  seekingVideo: true,
  recordingStart: null,
  recordingEnd: null,
  recordingDuration: null,
  playbackPosPct: null,
  playbackPosInMS: 0,
  currentIssueId: null,
});
export default makeInitialState;



// WEBPACK FOOTER //
// ./src/store/modules/recordings/initialState.js